import { ApiClient } from "@jace/api";
import { ReactNode, useMemo, useRef } from "react";
import { FileManager } from "../core/manager";
import { Provider } from "./file-manager-store";

export const FileManagerProvider = ({
	children,
	client,
	maxUploads,
	maxTotalSize,
	concurrency,
}: {
	children: ReactNode;
	client: ApiClient;
	maxUploads?: number;
	maxTotalSize?: number;
	concurrency?: number;
}) => {
	const manager = useRef(
		new FileManager(client, {
			uploads: {
				concurrent: concurrency ?? 1,
				maxCount: maxUploads ?? 10,
				maxSize: maxTotalSize ?? 10 * 1024 * 1024, // 10MB
				multiple: true,
			},
		}),
	);

	const ctx = useMemo(() => ({ manager: manager.current }), []);

	return <Provider value={ctx}>{children}</Provider>;
};
